module.exports = __webpack_public_path__ + "img/devto.e45dab88.svg";